import React, { useEffect, useState } from 'react';
import { AiOutlineCloudServer } from 'react-icons/ai';
import { BsCardChecklist } from 'react-icons/bs';
import { FaAndroid, FaApple } from 'react-icons/fa';
import { IoOpenOutline } from 'react-icons/io5';
import { MdColorLens, MdPhoneAndroid } from 'react-icons/md';
import { RiBookMarkFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';

import { StatusEnum } from '../../utils/enumerators/Status.enum';
import { getUser } from '../../utils/services/gitlab-service';
import PageDefault from '../PageDefault/PageDefault';

import './Home.scss';

function Home() {
	const [user, setUser] = useState(null);
	const [status, setStatus] = useState(StatusEnum.LOADING);

	useEffect(async () => {
		const userData = await getUser();
		setUser(userData);
		setStatus(StatusEnum.SUCCESS);
	}, []);

	return (
		<PageDefault status={status}>
			<div className="home container">
				{status == StatusEnum.LOADING && <span className="centered">Carregando...</span>}

				{status == StatusEnum.SUCCESS && (
					<>
						<div className="title">Olá, {user.name}</div>

						<div className="modules">
							<Link
								to="/versions"
								className="module"
								title="Ir para a página de aplicativos">
								<MdPhoneAndroid />
								<span>Aplicativos</span>
							</Link>

							<Link
								to="/status"
								className="module"
								title="Ver os status dos servidores">
								<AiOutlineCloudServer />
								<span>Status dos servidores</span>
							</Link>

							<a
								target="_blank"
								href="https://variaveis-b2c.vercel.app/"
								className="module"
								title="Ir para o gerador de cores">
								<MdColorLens />
								<div>
									<span>Gerador de Cores</span>
									<IoOpenOutline className="external" />
								</div>
							</a>

							<a
								target="_blank"
								href="https://sysmo-seu-super.notion.site/d918a729d55f4a15ba31797a6b12c86b?v=3ac11d6b8a5242f9816c7b2c8affaa6d"
								className="module"
								title="Ir para a documentação">
								<RiBookMarkFill />
								<div>
									<span>Documentação</span>
									<IoOpenOutline className="external" />
								</div>
							</a>
						</div>
						<div className="modules">
							<Link
								to="/build-ios"
								className="module"
								title="Ir para a página de Build iOS">
								<FaApple />
								<span>Build iOS</span>
							</Link>

							<Link
								to="/build-android"
								className="module"
								title="Ir para a página de Build Android">
								<FaAndroid />
								<span>Build Android</span>
							</Link>

							<Link
								to="/dashboard-android"
								className="module"
								title="Ir para o Dashboard Android">
								<BsCardChecklist />
								<span>Dashboard Android</span>
							</Link>
						</div>
					</>
				)}
			</div>
		</PageDefault>
	);
}

export default Home;
